import { z } from "zod";
export const createOrganisationSchema = z.object({
    name: z.string().trim().min(1).max(200),
});
export const updateOrganisationSchema = z.object({
    name: z.string().trim().min(1).max(200).optional(),
    status: z.enum(["ACTIVE", "SUSPENDED"]).optional(),
});
//# sourceMappingURL=organisations.js.map